import React from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SxProps,
} from "@mui/material";
import { ItemSubjectType, ResponseSubjectType, Template } from "../../types";

export interface Props {
  label: string;
  form?: Template;
  selected?: ResponseSubjectType;
  onChange: (subjectType: ResponseSubjectType) => void;
  sx?: SxProps;
}

export const SubjectTypeSelector = ({
  label,
  form,
  selected = ResponseSubjectType.Peer,
  onChange,
  sx,
}: Props) => {
  const peerSelfEntry =
    form &&
    form.items.some(
      (item) =>
        item.subjectType === ItemSubjectType.PeerSelf ||
        item.subjectType === ItemSubjectType.PeerOnly,
    )
      ? [{ id: ResponseSubjectType.Peer, label: "Peer and self-feedback" }]
      : [];
  // const peerOnlyEntry =
  //   form &&
  //   form.items.some((item) => item.subjectType === ItemSubjectType.PeerOnly)
  //     ? [{ id: ResponseSubjectType.Peer, label: "Peer only feedback" }]
  //     : [];
  const teamInstructorEntry =
    form &&
    form.items.some(
      (item) => item.subjectType === ItemSubjectType.TeamInstructors,
    )
      ? [
          {
            id: ResponseSubjectType.TeamInstructors,
            label: "Team instructor ratings",
          },
        ]
      : [];
  const generalEntry =
    form &&
    form.items.some((item) => item.subjectType === ItemSubjectType.General)
      ? [{ id: ResponseSubjectType.General, label: "General feedback" }]
      : [];
  const types = [...peerSelfEntry, ...teamInstructorEntry, ...generalEntry];

  return (
    <FormControl style={{ minWidth: 190, maxWidth: 190 }} size="small" sx={sx}>
      {/* Must not reuse CampaignSelector's ids: duplicate DOM ids made this
          combobox announce the Survey selector's label/value to AT. */}
      <InputLabel id="subject-type-select-label">{label}</InputLabel>
      <Select
        labelId="subject-type-select-label"
        id="subject-type-select"
        value={selected}
        label={label}
        onChange={(e) => onChange(e.target.value as ResponseSubjectType)}
      >
        {types.map((subjectType, index) => (
          <MenuItem key={index} value={subjectType.id}>
            {subjectType.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
